import api from '@/services/api/api';
import store from '@/store';

export default {
  namespaced: true,
  actions: {
    async getResource({ commit, state }, args) {
      const contacto_id = store.state.Auth.user.userId;

      const params = {
        resource_id: args.resource_id,
        include: 'resource_type,resources_ratings',
        attributes: [
          'resource_id', 'name', 'content', 'description', 'teachers_only', 'icon', 'is_introductory'
        ].join(',')
      }

      try {
        const response = await api.get(
          `/alumni/contactos/${contacto_id}/resources/${args.resource_id}`,
          { params }
        );

        return response.data
      } catch (err) {
        console.error(err);
      }
    },
  },
};
